const messages = {
  en: {
    '404err': '404 Page not found',
    '404title': 'Page not found',
    '404desc':
      'We are sorry but the page or article you are looking for does not exist.',
    homeLink: 'Click here to return to the home page',
    '500err': '500 Error',
    '500title': 'Oops! - Something went wrong'
  },
  'es-ud': {
    '404err': '404 Página no encontrada',
    '404title': 'Página no encontrada',
    '404desc': 'Lo sentimos, pero la página o el artículo que busca no existe.',
    homeLink: 'Haga clic aquí para volver a la página de inicio',
    '500err': '500 Error',
    '500title': '¡Vaya! Algo salió mal.'
  },
  es: {
    '404err': '404 Página no encontrada',
    '404title': 'Página no encontrada',
    '404desc': 'Lo sentimos, pero la página o el artículo que busca no existe.',
    homeLink: 'Haz clic aquí para volver a la página de inicio',
    '500err': '500 Error',
    '500title': '¡Vaya! Algo salió mal.'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/containers/Error/messages.js